module.exports = __webpack_public_path__ + "static/img/godetail.221ef99.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/godetail.gif
// module id = 4
// module chunks = 0